const SENSITIVE_SEGMENT_REGEX =
  /(?:email|token|password|secret|authorization)/gi;
const UUID_LIKE_REGEX =
  /[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}/gi;
const EMAIL_REGEX = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}/gi;

export const sanitizeBreadcrumbAction = (action: string): string => {
  if (!action) return action;

  let sanitized = action.replace(EMAIL_REGEX, '[email]');
  sanitized = sanitized.replace(UUID_LIKE_REGEX, '[id]');
  sanitized = sanitized.replace(SENSITIVE_SEGMENT_REGEX, '[redacted]');

  if (sanitized.length > 200) {
    sanitized = `${sanitized.slice(0, 200)}…`;
  }

  return sanitized;
};
